import { render, staticRenderFns } from "./PageCouponsCreate.vue?vue&type=template&id=2bc5b780&scoped=true&"
import script from "./PageCouponsCreate.vue?vue&type=script&lang=ts&"
export * from "./PageCouponsCreate.vue?vue&type=script&lang=ts&"
import style0 from "./PageCouponsCreate.vue?vue&type=style&index=0&id=2bc5b780&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc5b780",
  null
  
)

export default component.exports